@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/screen-width-breakpoints.module.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '~style-sheet-helpers/less/colors.less';

.edit-single-tote-modal {
  width: 673px;
}

.edit-single-tote-header {
  background-color: var(--grey-200);
  box-shadow: 0 1px 1px @new-order-modal--header--box-shadow-color;
  color: var(--grey-800);
  height: @space-32;
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    fill: var(--grey-800);
    transform: scale(0.4);
  }
}

.edit-single-tote-modal-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.modal-body {
  padding: @space-16;
}

.edit-single-tote-inputs {
  display: flex;
  margin-top: @space-8;
  gap: @space-16;
}

.edit-single-tote-input-container {
  width: 313px;
}

.button-container {
  margin-left: @space-16;
}

.button-styles {
  font-size: 12px;
  border-right: 1px solid var(--white);
  display: flex;
}

.edit-single-tote-input {
  margin: @space-0;
  padding-left: @space-0;
  text-align: left;
}
